<template>
  <v-autocomplete
    hide-details="auto"
    :items="suppliers"
    :loading="loading"
    v-model="filterDatas.supplier"
    item-text="name"
    item-value="id"
    label="Supplier"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.supplier)"
    :search-input.sync="searchSupplier"
  ></v-autocomplete>
</template>

<script>
import { mapState } from 'vuex';

import { SupplierListViewModel } from '../../models/View Models/Supplier';
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    suppliers: [],
    selectedSupplier: null,
    searchSupplier: null,
    loading: false,
  }),
  methods: {
    async emitInput(data) {
      if (this.filterDatas.isrouteNewPage == false) {
        await this.$store.commit('UPDATE_SUPPLIER_FILTER', data);
        this.$emit('input', this.filterDatas.supplier);
      } else {
        this.$emit('input', data);
      }
    },
    getSupplierByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('supplier/GetSupplierSearch', {
          query:
            this.filterDatas.isrouteNewPage == false
              ? this.filterDatas.supplierquery
              : query,
          status: 'active',
        })
        .then((res) => {
          this.loading = false;
          this.suppliers = res.map((u, i, arr) => {
            u.index = i + 1;
            return new SupplierListViewModel(u);
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapState(['filterDatas']),
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedSupplier = null;
      },
      deep: true,
    },
    searchSupplier: {
      handler(val) {
        if (this.filterDatas.isrouteNewPage == false) {
          this.$store.commit('UPDATE_SUPPLIER_QUERY_FILTER', val);
        }
        this.getSupplierByQuery(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.filterDatas.isrouteNewPage == false) {
      this.selectedSupplier = this.filterDatas.supplier;
      this.$emit('input', this.filterDatas.supplier);
    }
  },
  created() {
    this.getSupplierByQuery();
  },
};
</script>
